module.exports = __webpack_public_path__ + "static/img/preview-02.28e4fe3f.webp";